import { lazy } from 'react';

export const Login = lazy(() => import('./login/Login'));
export const Profile = lazy(() => import('./profile/Profile'));
export const Home = lazy(() => import('./home/Home'));
export const Application = lazy(() => import('./application/Application'));
export const Applications = lazy(() => import('./applications/Applications'));
export const Faq = lazy(() => import('./faq/Faq'));
export const TermsOfUse = lazy(() => import('./terms/TermsOfUse'));
export const PrivacyPolicy = lazy(() => import('./privacy/PrivacyPolicy'));
export const CompleteKYC = lazy(() => import('./kyc/CompleteKyc'));
export const CheckEligibility = lazy(() => import('./eligibility'));
export const InstantEligibility = lazy(() => import('./instantEligibility'));
